import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: 6,
				padding: 10,
				marginTop: 10
			},
			rewardText: {
				color: theme.palette.secondary.main,
				fontSize: 14
			},
			title: {
				fontSize: 14,
				marginTop: 7,
				color: theme.palette.primary.contrastText,
				fontWeight: 500
			},
			description: {
				fontSize: 13,
				color: theme.palette.primary.contrastText,
				lineHeight: "16px",
				marginTop: 5
			},
			product: {
				display: "flex",
				alignItems: "center",
				background: theme.palette.grey[600],
				borderRadius: 6,
				padding: 5,
				marginTop: 10
			},
			image: {
				width: 45,
				height: 45,
				padding: 2,
				borderRadius: 6,
				background: theme.palette.common.white,
				marginRight: 5,
				"& >img": {
					objectFit: "contain"
				}
			},
			nameProduct: {
				fontSize: 13,
				color: theme.palette.primary.contrastText,
				"& >span": {
					textTransform: "lowercase",
					color: theme.palette.error.light
				}
			}
		}),
	{
		name: "RewardMerchandising",
		index: 1
	}
);

export default useStyles;
